import { splitPascalCase } from '@ftr/foundation'

type Indexed<TValue> = Record<string, TValue>

export interface SelectItem<TEnum> {
  key: string
  value: TEnum
  id?: string
}

/**
 * Converts a number (non-string) enum to a list of SelectItems with key being the user-friendly enum key split on
 * capitals and value being the associated enum value.
 * @param {{}} numberEnum
 * @returns {SelectItem<number>[]}
 */
export function enumToSelectItemList(numberEnum: {}): SelectItem<number>[] {
  const indexedInput = numberEnum as Indexed<number>
  return Object.keys(indexedInput)
    .filter(k => typeof indexedInput[k] === 'number')
    .map(key => ({
      key: splitPascalCase(key),
      value: indexedInput[key],
    }))
}

/**
 * Converts a string enum to a list of SelectItems with key being the user-friendly enum key split on
 * capitals and value being the associated enum value.
 * @param {{}} stringEnum
 * @param keyProcessFn - an optional function to modify the key, splitPascalCase used by default
 * @returns {SelectItem<T>[]}
 */
export function stringEnumToSelectItemList<T>(
  stringEnum: {},
  keyProcessFn: Function = splitPascalCase,
): SelectItem<T>[] {
  return Object.keys(stringEnum).map(key => ({
    key: keyProcessFn(key),
    value: (stringEnum as {} as Record<string, string>)[key] as {} as T,
  }))
}

export function stringArrayToSelectItemList(items: string[]): SelectItem<string>[] {
  return items.map(item => ({
    key: item,
    value: item,
  }))
}
